/*
 * @Description: 菜单（tab算为横向菜单）
 * @Date: 2024-11-05 09:46:11
 */

import { ref } from 'vue';
import { defineStore } from 'pinia';
import _ from 'lodash';
import { Menus, Menu } from '@cTypes/user';
import { menuList } from '@/common/data-source/user/apis';
import { fieldsToMapping, fieldsToArr } from '@/utils/translator';
import router from '@/router';
import appStore from '@/store';
import { menusFormatting } from '@/hooks/use-menus';

const dealMenuForParent = (
  map: Map<string, any>,
  menus: Menus,
  parents = []
) => {
  if (!Array.isArray(menus)) return;
  menus.forEach(menu => {
    const _parent = [...parents, { name: menu.name, url: menu.url }];
    map.set(menu.url, _parent);
    dealMenuForParent(map, menu.menuList, _parent);
  });
};

const name = 'useMenuStoreSetup';
const useSetup = defineStore(
  name,
  () => {
    const menus = ref<Menus | []>([]); // 所有菜单
    const menu = ref<Menu | null>(null); // 当前菜单
    const menuUrls = ref<string[]>([]); // 所有菜单url
    const menuMapping = ref<{ [key in string]: Menu }>({}); // 菜单url与菜单的映射
    const menuParentInfo = ref<Map<string, any>>(new Map());
    const setMenus = async ({
      menubefore,
      menuAfter
    }: {
      menubefore: () => void;
      menuAfter: () => void;
    }) => {
      if (menubefore && typeof menubefore === 'function') await menubefore();
      await appStore.useUserStoreSetup.getUserFunction();
      const { data } = await menuList();

      // 本地注册路由
      // TODO: 需要遍历子应用注册路由
      const routeUrls = fieldsToArr(
        router.getRoutes(),
        'children',
        'path',
        true
      );

      menus.value = await menusFormatting(data);
      menuMapping.value = fieldsToMapping(menus.value, 'menuList', 'url');
      // route: 必存在有效path，如果有异常数据就是菜单配置的问题，为空就是没分配菜单。路由拦截会通过该变量进行重定向，取第一个。
      menuUrls.value = Object.keys(menuMapping.value).filter(item =>
        routeUrls.includes(item)
      );
      menuParentInfo.value = new Map();
      dealMenuForParent(menuParentInfo.value, data);
      if (menuAfter && typeof menuAfter === 'function') menuAfter();
      return Promise.resolve();
    };

    const routeForMenu = async (path: string) => {
      // TODO: 详情页面不会注册到菜单中，所以这个地方会为NULL。需要修改为如果不存在且是详情的路由需要添加个自定义菜单并有标识区分
      menu.value = menuMapping.value[path] || null;
    };
    return {
      menus,
      setMenus,
      menu,
      routeForMenu,
      menuUrls,
      menuMapping,
      menuParentInfo
    };
  },
  {
    persist: true
  }
);

export { useSetup, name };
